import { Link, Stack, StackProps, Text } from "@chakra-ui/react";

interface FooterSectionProps extends StackProps { }

export function FooterSection(props: FooterSectionProps) {
  return <Stack {...props} gap="4" />
}

interface FooterSectionTitleProps {
  title: string;
}

export function FooterSectionTitle({ title }: FooterSectionTitleProps) {
  return (
    <Text color="white" fontWeight="medium">{title}</Text>
  );
}

interface FooterSectionLinkProps {
  href: string;
  label: string;
}

export function FooterSectionLink({ href, label }: FooterSectionLinkProps) {
  return (
    <Link href={href}>
      <Text
        color="whiteAlpha.700"
        fontWeight="semibold"
        size="sm"
        _hover={{ textDecoration: "underline" }}
      >
        {label}
      </Text>
    </Link>
  );
}
